/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "fac",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "pl",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "pr",
                type: "int24",
            },
        ],
        name: "liquidities",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleX_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleY_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedY",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
        ],
        name: "liquiditySnapshot",
        outputs: [
            {
                internalType: "int128[]",
                name: "deltaLiquidities",
                type: "int128[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "liquidDelta",
                type: "uint128",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "x",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "y",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "mintDepositCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "notEnoughX",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "notEnoughY",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "setNotEnoughX",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "setNotEnoughY",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestMint__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(fac, overrides) {
        return super.deploy(fac, overrides || {});
    }
    getDeployTransaction(fac, overrides) {
        return super.getDeployTransaction(fac, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestMint__factory.bytecode = _bytecode;
TestMint__factory.abi = _abi;
